import React from 'react';

import styled from 'styled-components';

import { sendBrazeEvent } from 'apps/auth/analytics/braze';
import { BR_SYSTEM_GA_DOWN_RETRY } from 'apps/auth/constants/braze/brazeEvents';
import { usePageMessages } from 'apps/auth/hooks/selectors';

import { Row } from './Row';
import { Button } from '../Button/Button';
import { Icon } from '../Icon/Icon';
import { Text } from '../Text/Text';

type ContainerProps = {
    $isGaMigration?: boolean;
};

const Container = styled.div<ContainerProps>`
    max-width: 400px;
    padding: 0 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: ${(props) => (props.$isGaMigration ? 'relative' : 'absolute')};
    top: ${(props) => (props.$isGaMigration ? null : '50%')};
    left: ${(props) => (props.$isGaMigration ? null : '50%')};
    transform: ${(props) => (props.$isGaMigration ? null : 'translate(-50%, -50%)')};
    width: calc(100% - 48px);
`;

type StubPageProps = {
    isGaMigration?: boolean;
};

export const StubPage: React.FC<StubPageProps> = ({ isGaMigration }) => {
    const { accountsNoConnectionTitle, tryAgain } = usePageMessages<{ accountsNoConnectionTitle?: string; tryAgain?: string }>() ?? {};

    const refreshPage = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        sendBrazeEvent(BR_SYSTEM_GA_DOWN_RETRY);
        window.location.reload();
    };

    return (
        <Container $isGaMigration={isGaMigration}>
            <Row indent="16px">
                <Icon name="tools" color="secondary" />
            </Row>
            <Text color="secondary" textAlign="center">
                {accountsNoConnectionTitle}
            </Text>
            <Button caption={tryAgain} variant="row" textCenter onClick={refreshPage} />
        </Container>
    );
};
